// extracted by mini-css-extract-plugin
export var border = "_g-7";
export var brand = "_g-s";
export var button = "_g-k";
export var center = "_g-9";
export var centered = "_g-5";
export var closeButton = "_g-b";
export var disabledWrapper = "_g-l";
export var error = "_g-o";
export var extraLarge = "_g-4";
export var extraSmall = "_g-1";
export var fill = "_g-h";
export var footer = "_g-g";
export var footerAction = "_g-i";
export var footerButtons = "_g-j";
export var header = "_g-6";
export var headerWithClose = "_g-c";
export var icon = "_g-n";
export var info = "_g-r";
export var inline = "_g-8";
export var large = "_g-3";
export var main = "_g-d";
export var modal = "_g-0";
export var neutral = "_g-t";
export var noPadding = "_g-f";
export var none = "_g-u";
export var scrollable = "_g-e";
export var small = "_g-2";
export var success = "_g-q";
export var tight = "_g-m";
export var titleIcon = "_g-a";
export var warn = "_g-p";